import { ROWS_PER_PAGE } from "./rowPerPage";

export const Paths = {
  DASHBOARD_PATIENTS: "/dashboard/patients",
  PROVIDER_RESOURCES: "/dashboard/resources/provider",
  COORDINATOR_RESOURCES: "/dashboard/resources/coordinator",
  DASHBOARD: "/dashboard",
  PROVIDER_TASK_QUEUE: "/dashboard/queue/provider",
  COORDINATOR_TASK_QUEUE: "/dashboard/queue/coordinator",
  ORGANIZATION: "/dashboard/organization",
  EMPLOYEES: `/dashboard/organization/employees?p=0&l=${ROWS_PER_PAGE[0]}`,
  STATE_TRACKER: "/dashboard/state-tracker",
  CLIENTS: `/dashboard/patients?p=0&l=${ROWS_PER_PAGE[0]}&tp=true&order=desc&order_by=created_at`,
  WAITING_ROOM_TRACKER: `/dashboard/waiting-room-tracker?p=0&l=${ROWS_PER_PAGE[0]}&q=Provider`,
  FITNESS_AND_NUTRITION: `/dashboard/fitness-nutrition-plans?p=0&l=${ROWS_PER_PAGE[0]}`,
  PROMO_BANNERS: `/dashboard/promo-banners?p=0&l=${ROWS_PER_PAGE[0]}`,
  COUPONS: `/dashboard/coupons?p=0&l=${ROWS_PER_PAGE[0]}&status=active`,
  ORDERS: `/dashboard/orders?p=0&l=${ROWS_PER_PAGE[0]}`,
  MEDICATIONS: `/dashboard/medications?p=0&l=${ROWS_PER_PAGE[0]}`,
  CANCELLATIONS: `/dashboard/cancellations?p=0&l=${ROWS_PER_PAGE[0]}`,
  PRICES: "prices",
  INTAKES: "intakes",
  INTAKE_QUESTIONS: "questions",
  PRODUCT_MEDICATIONS: "medication",
  LOG_IN: "/login",
  CHATS: "/dashboard/chats",
  TITRATIONS_MANAGEMENT: `/dashboard/titrations-management?product=st&order=asc`,
  PROVIDER_AVAILABILITY: `/dashboard/organization/provider-availability?p=0&l=${ROWS_PER_PAGE[0]}`,
};
